import { css } from '@emotion/core';
import { styled, SkeletonLoaderText, pxToRem } from '@feast-it/ui/light';

export const Container = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing[10]};
  `
);

export const SkeletonHeaderContainer = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing[2]};
  `
);

export const SkeletonTitle = styled(SkeletonLoaderText)`
  width: 100%;
  max-width: ${pxToRem(640)};
`;

export const SkeletonDescription = styled(SkeletonLoaderText)`
  width: 100%;
  max-width: ${pxToRem(580)};
`;
